/**
 * Helpers partagés pour le mode historique des sessions.
 */
export function isSessionHistorique(session: { etat?: string | null } | null | undefined): boolean {
  if (!session?.etat) return false
  const etat = session.etat.toLowerCase()
  return (
    etat.includes('terminé') ||
    etat.includes('termine') ||
    etat.includes('annulé') ||
    etat.includes('annule')
  )
}

/**
 * True si la valeur d'un select/autocomplete n'est plus dans les items.
 * Évite l'affichage brut de l'ID quand le champ est vide ou grisé.
 */
export function isOrphanSelectId(
  value: number | string | null | undefined,
  items: Array<{ id?: number | string } | null | undefined> | null | undefined
): boolean {
  if (value === null || value === undefined || value === '') return false
  const id = Number(value)
  if (!Number.isFinite(id)) return true
  return !(items || []).some((item) => item != null && Number(item.id) === id)
}

/**
 * Filtre une sélection multiple pour ne garder que les IDs encore présents dans items.
 */
export function pruneOrphanSelectIds(
  values: Array<number | string> | null | undefined,
  items: Array<{ id?: number | string } | null | undefined> | null | undefined
): number[] {
  if (!values?.length) return []
  const allowed = new Set(
    (items || [])
      .map((item) => (item != null ? Number(item.id) : NaN))
      .filter((id) => Number.isFinite(id))
  )
  return values.map(Number).filter((id) => allowed.has(id))
}
